/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Промежуточное состояние отслеживания
 */
export type TrackingItem = {
  /**
   * Идентификатор статуса
   */
  statusId: TrackingItem.statusId
  /**
   * Наименование статуса
   */
  statusName: string
  /**
   * Дата и время изменения статуса
   */
  dateTime: string
  /**
   * Идентификатор терминала (Id склада из деливери)
   */
  terminalId: string
  /**
   * Название терминала
   */
  terminalName: string
}
export namespace TrackingItem {
  /**
   * Идентификатор статуса
   */
  export enum statusId {
    DEPARTURE_COURIER_ASSIGNED = 'departureCourierAssigned',
    DEPARTURE_COURIER = 'departureCourier',
    DEPARTURE_TERMINAL = 'departureTerminal',
    TRANSIT = 'transit',
    DESTINATION_TERMINAL = 'destinationTerminal',
    DESTINATION_COURIER_ASSIGNED = 'destinationCourierAssigned',
    DESTINATION_COURIER = 'destinationCourier',
    DELIVERED = 'delivered',
    CANCEL = 'cancel'
  }
}
